import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery, queryPost } from '@/utils';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => queryPost('/account/local/token/issue', body),
    }),
    changePassword: builder.mutation({
      query: (body) => queryPost('/account/changepassword', body),
    }),
  }),
});

export const { useLoginMutation, useChangePasswordMutation } = authApi;
